var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{staticClass:"g-tip",attrs:{"closable":""}},[_c('Icon',{staticClass:"g-tip-icon",attrs:{"type":"ios-information-circle-outline","size":"20"}}),_c('span',[_vm._v(_vm._s(_vm.notice))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }